import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import { useScreenSize } from '@/hooks';
import P2PTradePanel from './P2PTradePanel/P2PTradePanel';
import VaultProPanel from './VaultProPanel/VaultProPanel';
import MobileVaultPanel from './MobileVaultPanel/MobileVaultPanel';
import MobileP2PPanel from './MobileP2PPanel/MobileP2PPanel';
import styles from './HomeBannerStrip.module.css';

const HomeBannerStrip = () => {
  const { isMobile, isTablet } = useScreenSize();

  if (isMobile || isTablet) {
    return (
      <div className={styles.swiperWrap}>
        <Swiper
          modules={[Autoplay]}
          slidesPerView={1.08}
          spaceBetween={10}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          className={styles.swiper}
        >
          <SwiperSlide><MobileP2PPanel /></SwiperSlide>
          <SwiperSlide><MobileVaultPanel /></SwiperSlide>
        </Swiper>
      </div>
    );
  }

  return (
    <div className={styles.strip}>
      <P2PTradePanel />
      <VaultProPanel />
    </div>
  );
};

export default HomeBannerStrip;
